export default "__VITE_ASSET__CHJCP7e___"